import React from "react";
import {
  FeeSummaryPopUp,
  LoaderWrapper,
  ManageFeeLayout,
  WarningModal,
} from "../../../components";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import { getFeeSummaryDetailsById } from "../../../services";
import BasicDetailsConatiner from "./BasicDetailsContainer";
import FeeApplicableToContainer from "./FeeApplicableToContainer";
import FeeCalculationContainer from "./FeeCalculationConatiner";
import ScheduleRunSummaryContainer from "./ScheduleRunSummaryContainer";
import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import {
  appLayoutStore,
  globalToastInfo,
  manageFeeStore,
  setFeeIdInfo,
  setFeeSummaryInfo,
  setManageFeeFlow,
  setManageFeeToastInfo,
} from "../../../contexts";
import { saveSummaryDetails } from "../../../services";

import { useContext } from "react";
import { Formik } from "formik";
import {
  MANAGE_FEE_ROUTES,
  ROUTES,
  getPathWithParam,
  getAdvancedPathWithParam,
  FLOW_TYPES,
} from "../../../utils";

const SummaryContainer = (props) => {
  const { history } = props;
  const [showPopup, setShowpopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [basicDetailsResponse, setBasicDetailsResponse] = useState([]);
  const [feeCalculationResponse, setFeeCalculationResponse] = useState([]);
  const [feeApplicableToResponse, setFeeApplicableToResponse] = useState([]);
  const [scheduleRunResponse, setScheduleRunResponse] = useState([]);
  const handleCancelClick = () => {
    setShowpopup(false);
  };
  const { flow, feeId } = useRouterParams();
  const { state, dispatch } = useContext(manageFeeStore);
  const feeName = basicDetailsResponse.name;
  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    setIsLoading(true);
    saveSummaryDetails(feeId)
      .then((response) => {
        setIsLoading(false);
        dispatch(setFeeSummaryInfo(response));
        if (response.isSuccessful) {
          dispatch(
            globalToastInfo({
              showToast: true,
              toastMessage: (
                <div>
                  <div className="summary-success-toast-text">{` New Fee Created Successfully!`}</div>
                  <div className="summary-success-toast-sub-text">{`${feeName} created.`}</div>
                </div>
              ),
            })
          );
        }

        // dispatch(
        //   setFeeSummaryInfo({
        //     showToast: true,
        //     toastMessage: (
        //       <div>
        //         <p className="success-toast-text">{` New Fee Created Successfully`}</p>
        //         <p className="success-toast-sub-text">{`feename created  .`}</p>
        //       </div>
        //     ),
        //   })
        // );
        history.push(
          getPathWithParam({
            path: MANAGE_FEE_ROUTES.MANAGE_FEE,
            // pathParam: [FLOW_TYPES.EDIT, response?.calculationDetails?.id],
          })
        );
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useDeepEffect(() => {
    setIsLoading(true);
    getFeeSummaryDetailsById(feeId)
      .then((response) => {
        setIsLoading(false);
        setBasicDetailsResponse(response?.feeSummary?.basicFeeDetails);
        setFeeCalculationResponse(response?.feeSummary?.calculationDetails);
        setFeeApplicableToResponse(response?.feeSummary?.feeApplicableTo);
        setScheduleRunResponse(response?.feeSummary?.feeSchedule);
        dispatch(
          setFeeIdInfo({
            id: response?.feeSummary?.basicFeeDetails.id,
            step: response?.feeSummary?.basicFeeDetails.step,
          })
        );
      })
      .catch((error) => {});
  }, []);

  const initialValues = {};
  return (
    <LoaderWrapper isLoading={isLoading}>
      <Formik
        onSubmit={onFormSubmit}
        initialValues={{
          ...initialValues,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          setValues,
          setFieldError,
          setTouched,
          setFieldTouched,
          handleSubmit,
          errors,
          values,
          ...rest
        }) => {
          const button = [
            {
              label: "Cancel",
              variant: "secondary",
              type: "button",
              link: ROUTES.FEE,
              //flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
              //onClick: onAddClick,
            },
            {
              label: "Submit",
              variant: "primary",

              onClick: () => {
                {
                  scheduleRunResponse?.feeRunType == 1 &&
                  scheduleRunResponse.feeProcess == 1
                    ? setShowpopup(true)
                    : onFormSubmit(values, setFieldError, setFieldTouched);
                }
              },
            },
          ];

          const editButtons = [
            {
              label: "Cancel",
              variant: "secondary",
              type: "button",
              flow: [FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
              link: ROUTES.FEE,
            },
            {
              label: "Edit",
              variant: "primary",
              type: "button",
              flow: [FLOW_TYPES.EDIT],
              onClick: () =>
                history.push(
                  getAdvancedPathWithParam({
                    path: MANAGE_FEE_ROUTES.BASIC_DETAILS,
                    pathParam: [FLOW_TYPES.SAVE, feeId],
                  })
                ),
            },
          ];
          const handleConfirmClick = () => {
            onFormSubmit(values, setFieldError, setFieldTouched);
          };

          return (
            <div style={{ overflow: "scroll", maxHeight: "100%" }}>
              <ManageFeeLayout
                isCreateFee={true}
                layoutHeader="Summary"
                pageFlow={flow}
                buttons={basicDetailsResponse.step < 5 ? button : editButtons}
              >
                <div>
                  <p className="fw-600 ft-18" style={{ color: "#333" }}>
                    Basic Details
                    {console.log(
                      "hfu",
                      basicDetailsResponse.step,
                      basicDetailsResponse.step < 5
                    )}
                  </p>
                  <BasicDetailsConatiner
                    basicDetailsResponse={basicDetailsResponse}
                  />
                  <br></br>
                  <p className="fw-600 ft-18" style={{ color: "#333" }}>
                    Fee Calculation
                  </p>
                  <FeeCalculationContainer
                    feeCalculationResponse={feeCalculationResponse}
                  />
                  <br></br>
                  <p className="fw-600 ft-18" style={{ color: "#333" }}>
                    Fee Applicable To
                  </p>
                  <FeeApplicableToContainer
                    feeApplicableToResponse={feeApplicableToResponse}
                  />
                  <br></br>
                  <p className="fw-600 ft-18" style={{ color: "#333" }}>
                    Schedule / Run
                  </p>
                  <ScheduleRunSummaryContainer
                    scheduleRunResponse={scheduleRunResponse}
                  />
                </div>
              </ManageFeeLayout>

              <FeeSummaryPopUp
                showPopup={showPopup}
                setShowpopup={setShowpopup}
                handleCancelClick={handleCancelClick}
                handleConfirmClick={handleConfirmClick}
              />
            </div>
          );
        }}
      </Formik>
    </LoaderWrapper>
  );
};
export default SummaryContainer;
